// export const apiUrl = window.location.hostname.includes('localhost') ? 'http://localhost:8000/api' : 'http://142.93.1.246/api';
// tslint:disable-next-line:max-line-length
export const apiUrl = window.location.hostname.includes('localhost') ? 'http://localhost:8000/api' : `https://${window.location.hostname}/api`;
// export const apiUrl = window.location.hostname.includes('localhost') ? 'http://pricing.kitchendev.test/api' : `https://${window.location.hostname}/api`;
